import message from "@/utils/globalMessage";
import React from 'react';
import { Dropdown } from "antd";
import {
  MoreOutlined,
  FolderOpenOutlined,
  FileOutlined,
  AppstoreOutlined,
  EditOutlined,
  TagOutlined,
  ReloadOutlined,
  DownloadOutlined,
  DeleteOutlined,
  ScissorOutlined,
  ChromeOutlined,
  HighlightOutlined,
  ShareAltOutlined,
  StarOutlined,
} from '@ant-design/icons';
import { api } from '@/redux/api';
import { canOpenInApp, copyLink, getSafeUrl, handleDownload, openInApp, openInBrowser } from './utils';


export const DropdownMenu = ({
  record,
  currentFileRef,
  openEditModal,
  setIsDeleteOpen,
  setIsFileOpen,
  setCurrentOpenFile,
  reload,
  setCurrentTreeKeyWithClearSearch,
  deleteFile,
  openEditTagModal,
  openRenameModal,
  openMoveToModal,
  canWrite,
  canFullAccess,
  userId,
  isFavorited,
  toggleFavorite,
  trigger = 'click',
  children
}) => {

  const isFolder = record.isFolder;
  const isOwner = record.createdby === userId;
  const canDeleteRecord = canFullAccess || isOwner;

  // const handleDownload = async (record) => {

  //   const { image: downloadUrl, name } = record;

  //   const generate_url = await api.generate_url(getSafeUrl(downloadUrl), false).then(
  //     response => {
  //       const url = response.data.url;
  //       return url
  //     })

  //   const link = document.createElement('a');
  //   link.href = generate_url;
  //   link.setAttribute('download', name);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link)
  // }


  const menuItems = [
    {
      key: 'group1',
      type: 'group',
      children: isFolder ? [{ key: '1', icon: <FolderOpenOutlined />, label: 'Open Folder', onClick: () => setCurrentTreeKeyWithClearSearch(record) }] :
        [
          {
            key: '2', icon: <FileOutlined />, label: 'Open', onClick() {
              setIsFileOpen(true)
              setCurrentOpenFile(record)
            }
          },
          ...(canOpenInApp(record) ? [{
            key: '3', icon: <ChromeOutlined />, label: 'Open in Browser', onClick: async () => {
              openInBrowser(record)
            }
          }] : []),
          ...(canOpenInApp(record) ? [{
            key: '4', icon: <AppstoreOutlined />, label: 'Open in App', onClick: async () => {
              openInApp(record)
            }
          }] : [])
        ],
    },
    { type: 'divider' },
    {
      key: 'group2',
      type: 'group',
      children: [
        ...(canWrite ? [{
          key: '5', icon: <EditOutlined />, label: 'Edit', onClick: () => {
            openEditModal(record)
          }
        }] : []),
        ...(canWrite ? [{
          key: '6', icon: <HighlightOutlined />, label: 'Rename', onClick() {
            openRenameModal(record)
          }
        }] : []),
        ...(!isFolder && canWrite ? [{
          key: '7', icon: <TagOutlined />, label: 'Edit Tags', onClick() {
            openEditTagModal(record)
          }
        }] : [])
        // { key: '7', icon: <CategoryOutlined />, label: 'Edit Category' },
        // { key: '8', icon: <FileTextOutlined />, label: 'Edit Description' },
      ],
    },
    { type: 'divider' },
    {
      key: 'group3',
      type: 'group',
      children: [
        ...(isFolder ? [] : [{
          key: '10', icon: <DownloadOutlined />, label: 'Download', onClick() {
            handleDownload(record)
          }
        }]),
        { key: '9', icon: <ReloadOutlined />, label: 'Refresh', onClick: reload },
        ...(canDeleteRecord ? [{
          key: '11', icon: <DeleteOutlined />, label: 'Delete', onClick() {
            deleteFile(record)
          }
        }] : []),
      ],
    },
    { type: 'divider' },
    {
      key: 'group4',
      type: 'group',
      children: [
        // { key: '12', icon: <CopyOutlined />, label: 'Copy To' },
        ...(isFolder ? [] : [{
          key: '14', icon: <ShareAltOutlined />, label: 'Copy Link', onClick() {
            copyLink(record)
          }
        }]),
        ...(canWrite ? [{
          key: '13', icon: <ScissorOutlined />, label: 'Move To', onClick() {
            openMoveToModal(record)
          }
        }] : []),
      ],
    },
    { type: 'divider' },
    {
      key: 'group5',
      type: 'group',
      children: [
        {
          key: '15', icon: <StarOutlined />, label: isFavorited ? 'Remove from Favorites' : 'Add to Favorites',
          onClick() { toggleFavorite(record.id); }
        },
      ],
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: menuItems }}
        trigger={[trigger]}
        overlayClassName="file-context-menu-overlay"
        overlayStyle={{ minWidth: 180 }}
      >
        {children ? children : <MoreOutlined style={{ cursor: 'pointer', fontSize: 16, padding: 4, borderRadius: 4, transition: 'background 0.15s ease' }} />}
      </Dropdown>
    </>
  );
};
